'use client';

import Modal from '../modal';
import { MainRateCardDialogComponent } from './body-component';
import { BedType, DialogOfferDataType } from '../types';

export type RateCardProps = {
	openDialog?: boolean;
	locale?: string;
	offerData?: DialogOfferDataType;
	selectedBedData?: BedType;
	isMultiRoom?: boolean;
	isCartEnabled?: boolean;
	focusContainerClassNames?: string;
	mainRateComponentContainerClassName?: string;
	mainContainerClassName?: string;
	isPreferredPartner?: boolean;
	handleBedOptionsSelect?: (args: { isInDialog?: boolean } | undefined) => void;
	handleAddToCart?: (args: { isInDialog?: boolean } | undefined) => void;
	handleSelectOrBookNow?: (args: { isInDialog?: boolean } | undefined) => void;
	closeModal?: () => void;
	allInPricing?: boolean;
	isInRateDialog?: boolean;
	ppMode?: boolean;
};

export const RateCardDialog = ({
	offerData,
	locale,
	isCartEnabled,
	isMultiRoom,
	mainRateComponentContainerClassName,
	isPreferredPartner,
	handleBedOptionsSelect,
	handleAddToCart,
	handleSelectOrBookNow,
	closeModal,
	allInPricing,
	isInRateDialog,
	ppMode,
}: RateCardProps) => {
	return (
		<Modal close={closeModal} focusContainerClassNames="md:h-auto" mobileFullScreen={false}>
			<MainRateCardDialogComponent
				offerData={offerData}
				locale={locale}
				isCartEnabled={isCartEnabled}
				isMultiRoom={isMultiRoom}
				handleAddToCart={handleAddToCart}
				handleSelectOrBookNow={handleSelectOrBookNow}
				handleBedOptionsSelect={handleBedOptionsSelect}
				mainContainerClassName={mainRateComponentContainerClassName}
				isPreferredPartner={isPreferredPartner}
				allInPricing={allInPricing}
				isInRateDialog={isInRateDialog}
				ppMode={ppMode}
			/>
		</Modal>
	);
};

export default RateCardDialog;
